import { Reducer } from "redux";

import { TabSessionStorageDispatchTypes } from "../constants/TabSessionStorage";
import { TabSessionStorageResponse } from "../models/Api/TabSessionStorage";
import { TabSessionDataDispatchTypes } from "../models/DispatchTypes/TabSessionStorage";

export const initialState: TabSessionStorageResponse = {
  loading: false,
  response: {
    patientDetail: {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      subscriberId: "",
      isManual: false,
      eligibilityPayerId: "",
      eligibilityPayerName: "",
      phone: "",
      extension: "",
      languageId: -1,
      gender: "",
      isBcbsmiAuth: null,
      response: null,
      residentialAddress: {
        streetName1: "",
        streetName2: "",
        county: "",
        city: "",
        patientState: "",
        zipCode: "",
        latitude: -1,
        longitude: -1,
        addressTypeId: -1,
        country: "",
      },
    },
    emergencyContact: null,
    referralSource: {
      facilityTypeId: "",
      facilityTypeName: "",
      facilityName: "",
      referralSourceName: "",
      referralSourceExtension: "",
      referralSourcePhoneNo: "",
      referralSourceFax: "",
      referralSourceNpi: "",
    },
    requester: {
      facilityName: "",
      facilityTypeId: "",
      facilityTypeName: "",
      requesterExtension: "",
      requesterFax: "",
      requesterName: "",
      requesterNpi: "",
      requesterPhoneNo: "",
    },
    orderingPhysician: {
      physicianName: "",
      physicianNpiId: "",
      phoneExt: "",
      phoneNo: "",
      streetName1: "",
      streetName2: "",
      fax: "",
      county: "",
      city: "",
      physicianState: "",
      zipCode: "",
      physicianTypeId: 2,
      latitude: -1,
      longitude: -1,
    },
    primaryPhysician: null,
    serviceAddress: {
      streetName1: "",
      streetName2: "",
      county: "",
      city: "",
      patientState: "",
      zipCode: "",
      latitude: -1,
      longitude: -1,
      addressTypeId: -1,
      country: "",
    },
    serviceProvider: {
      serviceProviderId: -1,
      serviceProviderName: "",
      phone: "",
      extension: "",
      contactName: "",
      email: "",
      fax: "",
      streetName1: "",
      streetName2: "",
      county: "",
      country: "",
      city: "",
      serviceLocationState: "",
      zipCode: "",
    },
    diagnosisCode: [
      {
        diagnosisTypeId: -1,
        diagnosisCode: "",
        diagnosisCodeDescription: "",
        icdDiagnosisCodeId: -1,
        diagnosisType: "",
      },
    ],
    serviceRequest: {
      startOfCareDate: "",
      needDescription: "",
      careType: [
        {
          careTypeId: -1,
          careTypeName: "",
        },
      ],
      discipline: [
        {
          disciplineId: -1,
          disciplineName: "",
          disciplineDescription: "",
        },
      ],
    },
    referralBlobDetail: [],
    reviewDetail: {
      FToFEncounterDate: null,
      ProviderName: "",
      medicaidMedicareChecked: false,
    },
  },
  error: null,
};

const TabSessionReducer: Reducer<
  TabSessionStorageResponse,
  TabSessionDataDispatchTypes
> = (state = initialState, action: any) => {
  switch (action.type) {
    case TabSessionStorageDispatchTypes.SET_TAB_DATA_INVOKE: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case TabSessionStorageDispatchTypes.SET_TAB_DATA_SUCCESS:
      return { ...state, response: action.response, loading: false, error: {} };
    default:
      return state;
  }
};

export default TabSessionReducer;
